import { render, staticRenderFns } from "./accountRecord.vue?vue&type=template&id=32855a69&scoped=true"
import script from "./accountRecord.vue?vue&type=script&lang=js"
export * from "./accountRecord.vue?vue&type=script&lang=js"
import style0 from "./accountRecord.vue?vue&type=style&index=0&id=32855a69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32855a69",
  null
  
)

export default component.exports